module.exports = __webpack_public_path__ + "static/home-video-b4148afda0a7c7d2c566b961f9fcc49d.webm";